import { Link } from "react-router-dom";
import {
    Typography,
    Card,
    CardContent,
    Stack,
} from "@mui/material";
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';

import { MessageCardProps } from "interfaces/messages.d";

const MessageCard = ({
    id,
    title,

}: MessageCardProps) => {

    
    return (

        <Card
            component={Link}
            to={`/messages/show/${id}`}
            sx={{
                bgcolor: "#fcfcfc",
                width: "40vh",
                maxWidth: "330px",
                padding: "10px",
                "&:hover": {
                    boxShadow: "0 22px 45px 2px rgba(176, 176, 176, 0.3)",
                },
                cursor: "pointer",
            }}
            elevation={0}
        >
            
            <CardContent
                sx={{
                    display: "flex",
                    width: "40vh",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    gap: "10px",
                    paddingX: "5px",
                }}
            >
                <Stack direction="column" gap={1}>
                <Typography fontSize={16} fontWeight={500} color="#1D78B2">
                        <ChatOutlinedIcon/>
                    </Typography>
                    <Typography fontSize={16} fontWeight={500} color="#11142d">
                        {title}
                    </Typography>
                    <Stack direction="row" gap={0.5} alignItems="flex-start">
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default MessageCard;